import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAxios } from './context.mjs';
import { useReferenceSafeObject } from './hooks/useReferenceSafeObject.mjs';
import makeQuery from './utils/makeQuery.mjs';

const DEFAULT_EXACT_VALUE = true;
function useQueryActionsFromRemote(params) {
  const queryClient = useQueryClient();
  const { instances } = useAxios();
  const { key: rawKey } = makeQuery(params, instances.json);
  const key = useReferenceSafeObject(rawKey);
  const getQueryData = useCallback(
    (filters) => {
      return queryClient.getQueryData(key, filters);
    },
    [key, queryClient]
  );
  const removeQueryData = useCallback(
    (filters) => {
      return queryClient.removeQueries(key, filters);
    },
    [key, queryClient]
  );
  const invalidate = useCallback(
    ({ exact = DEFAULT_EXACT_VALUE, ...restFilter } = {}, invalidateOptions) => queryClient.invalidateQueries(
      key,
      { exact, ...restFilter },
      invalidateOptions
    ),
    [key, queryClient]
  );
  const setQueryData = useCallback(
    (updater, setQueryDataOptions) => {
      return queryClient.setQueryData(key, updater, setQueryDataOptions);
    },
    [key, queryClient]
  );
  const cancelQuery = useCallback(
    ({ exact = DEFAULT_EXACT_VALUE, ...restFilter } = {}) => {
      return queryClient.cancelQueries(key, { exact, ...restFilter });
    },
    [key, queryClient]
  );
  const refetch = useCallback(
    ({
      exact = DEFAULT_EXACT_VALUE,
      ...restFilter
    } = {}, options) => {
      return queryClient.refetchQueries(
        key,
        {
          exact,
          ...restFilter
        },
        options
      );
    },
    [key, queryClient]
  );
  return {
    key,
    refetch,
    invalidate,
    setQueryData,
    removeQueryData,
    getQueryData,
    cancelQuery
  };
}

export { useQueryActionsFromRemote as default };
//# sourceMappingURL=useQueryActionsFromRemote.mjs.map
